import { ChartPieSlice, GearSix, ListBullets, type Icon } from '@phosphor-icons/react';
import { ROUTES } from '../../../shared/constants/app.constant';

export interface NavItem {
  readonly to: string;
  readonly label: string;
  readonly icon: Icon;
  readonly end?: boolean;
  readonly showPendingBadge?: boolean;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { to: ROUTES.dashboard, label: 'Ringkasan', icon: ChartPieSlice, end: true },
  { to: ROUTES.transactions, label: 'Transaksi', icon: ListBullets },
  { to: ROUTES.settings, label: 'Pengaturan', icon: GearSix, showPendingBadge: true },
];

export const MOBILE_NAV_ITEMS: readonly NavItem[] = [
  { to: ROUTES.dashboard, label: 'Ringkasan', icon: ChartPieSlice, end: true },
  { to: ROUTES.transactions, label: 'Transaksi', icon: ListBullets },
];

